<template>
  <div style="margin-bottom: 10px">
    <!-- 付费率的计算 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>虚假付费率的计算（如果活动已经开始，此配置项要到活动下一轮才会生效）</span>
      </div>
      <el-form label-position="left" label-width="140px" size="mini">
        <el-form-item label="最大值的随机范围：">
          <el-input placeholder="比如0.91" v-model="data.paidRateComputation.maxValueRandom1" style="width: 100px"></el-input>
          <span> - </span>
          <el-input placeholder="比如0.95" v-model="data.paidRateComputation.maxValueRandom2" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item label="衰减率的随机范围：">
          <el-input placeholder="比如0.0003" v-model="data.paidRateComputation.decayRateRandom1" style="width: 100px"></el-input>
          <span> - </span>
          <el-input placeholder="比如0.0005" v-model="data.paidRateComputation.decayRateRandom2" style="width: 100px"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 各类型的每日奖励 -->
    <el-card v-for="typedDailyReward in data.typedDailyRewards" :key="typedDailyReward.type" class="box-card"
      style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>{{ typedDailyReward.typeName }}</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditWishActivityDailyRewardDialog(typedDailyReward.type, true, null)">新增{{
      typedDailyReward.typeName }}</el-button>
      </div>
      <el-table :data="typedDailyReward.days" border size="small" style="width: 551px; margin-top: 10px">
        <el-table-column label="第几天" align="center" width="100">
          <template scope="scope">
            {{ scope.row.day }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="label" label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red"
              @click="removeTypedDailyReward(typedDailyReward.type, scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditWishActivityDailyRewardDialog(typedDailyReward.type, false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 各排名的奖励 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>排名奖励</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditActivityLeaderboardDialog(true, null)">新增排名奖励</el-button>
      </div>
      <el-table :data="data.leaderboard.rankingRanges" border size="small" style="width: 551px; margin-top: 10px">
        <el-table-column prop="range" label="排名区间" align="center" width="100">
          <template scope="scope">
            {{ scope.row.range[0] == scope.row.range[1] ? scope.row.range[0] :
      `${scope.row.range[0]} - ${scope.row.range[1]}` }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="label" label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="removeLeaderboardRankingEntry(scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditActivityLeaderboardDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 返利奖励 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>返利奖励</span>
      </div>
      <div>
        <base-item-selector v-model="data.rebateRewards" @updated="onRebateRewardsUpdated"></base-item-selector>
      </div>
    </el-card>

    <!-- 各个任务 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>任务</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditActivityTaskDialog(true, null)">新增任务</el-button>
      </div>
      <el-table :data="data.tasks" border size="small" style="width: 851px; margin-top: 10px">
        <el-table-column show-overflow-tooltip label="任务Key" align="center" width="100" fixed>
          <template scope="scope">
            {{ scope.row.key }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="解锁类型" align="center" width="100" fixed>
          <template scope="scope">
            {{ scope.row.unlockType }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="解锁参数" align="center" width="100" fixed>
          <template scope="scope">
            {{ scope.row.unlockParams }}
          </template>
        </el-table-column>         
        <el-table-column show-overflow-tooltip label="任务类型" align="center" width="100" fixed>
          <template scope="scope">
            {{ scope.row.taskType }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="任务条件" align="center" width="100">
          <template scope="scope">
            {{ scope.row.schedule }}
          </template>
        </el-table-column>        
        <el-table-column show-overflow-tooltip label="类型判断" align="center" width="100">
          <template scope="scope">
            {{ scope.row.typeDetermination }}
          </template>
        </el-table-column>        
        <el-table-column show-overflow-tooltip label="任务描述" align="center" width="200">
          <template scope="scope">
            {{ scope.row.taskInfo }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="label" label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="奖励领取方式" align="center" width="100">
          <template scope="scope">
            {{ scope.row.collectionMethod }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red"
              @click="removeTask(scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditActivityTaskDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>    

    <!-- 各个成就 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>成就</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditWishActivityAchievementDialog(true, null)">新增成就</el-button>
      </div>
      <el-table :data="data.achievements" border size="small" style="width: 851px; margin-top: 10px">
        <el-table-column show-overflow-tooltip label="成就类型" align="center" width="200">
          <template scope="scope">
            {{ scope.row.type }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="成就参数" align="center" width="200">
          <template scope="scope">
            {{ scope.row.params }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red"
              @click="removeAchievement(scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditWishActivityAchievementDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import ShowItems from "@/pages/activity/activity_parameter_template/components/ShowItems";
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

export default {
  data() {
    return {
      data: {
        misc: "{}",
        typedDailyRewards: [
          {
            type: "primary",
            typeName: "初级奖励",
            days: [],
          },
          {
            type: "advanced",
            typeName: "进阶奖励",
            days: [],
          }
        ],
        leaderboard: {
          rankingRanges: [], // 各个排名区间
        },
        rebateRewards: [], // 返利奖励
        tasks: [], // 任务
        achievements: [], // 成就
        paidRateComputation: { // 付费率计算
          maxValueRandom1: 0.99,
          maxValueRandom2: 0.99,
          decayRateRandom1: 0.0003,
          decayRateRandom2: 0.0003,
        }
      },
    };
  },

  components: {
    ShowItems,
    BaseItemSelector,
  },

  props: {
    parameters: "",
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    if (this.parameters) {
      this.data = JSON.parse(this.parameters);
      if (!this.data.paidRateComputation) {
        this.data.paidRateComputation = {}
      }
    }
  },

  methods: {
    async onRebateRewardsUpdated(value) {
      this.data.rebateRewards = value;
      await this.updatedParam();
    },

    async openEditWishActivityDailyRewardDialog(type, isCreated, entry, index) {
      let targetEntry = null;
      if (entry) {
        targetEntry = {
          day: entry.day,
          rewards: entry.rewards,
        };
      }

      let typedDailyReward = this.data.typedDailyRewards.find((x) => {
        return x.type == type;
      });

      this.$dialogutil.open("EditWishActivityDailyRewardDialog", {
        closedCallback: async (entry) => {
          console.log("entry:", entry)

          if (entry != null) {
            let localEntry = {
              day: entry.day,
              rewards: entry.rewards,
            };

            if (isCreated) {
              typedDailyReward.days.push(localEntry);
            } else {
              this.$set(typedDailyReward.days, index, localEntry);
            }

            typedDailyReward.days.sort((x, y) => {
              return x.day - y.day;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, typeName: typedDailyReward.typeName, entry: targetEntry },
      });
    },

    async removeTypedDailyReward(type, index) {
      try {
        let typedDailyReward = this.data.typedDailyRewards.find((x) => {
          return x.type == type;
        });

        let dayEntry = typedDailyReward.days[index];

        // 弹确认框
        await this.$confirm(
          `确认删除第${dayEntry.day}天的奖励配置？`
        );

        typedDailyReward.days.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async openEditActivityTaskDialog(isCreated, entry, index) {
      let targetEntry = null;
      if (entry) {
        targetEntry = {
          key: entry.key,
          unlockType: entry.unlockType,
          unlockParams: entry.unlockParams,
          taskType: entry.taskType,
          typeDetermination: entry.typeDetermination,
          taskInfo: entry.taskInfo,
          schedule: entry.schedule,
          rewards: entry.rewards,
          collectionMethod: entry.collectionMethod,
        };
      }

      this.$dialogutil.open("EditActivityTaskDialog", {
        closedCallback: async (entry) => {
          if (entry != null) {
            let localEntry = {
              key: entry.key,
              unlockType: entry.unlockType,
              unlockParams: entry.unlockParams,
              taskType: entry.taskType,
              typeDetermination: entry.typeDetermination,
              taskInfo: entry.taskInfo,
              schedule: entry.schedule,
              rewards: entry.rewards,
              collectionMethod: entry.collectionMethod,
            };

            if (isCreated) {
              this.data.tasks.push(localEntry);
            } else {
              this.$set(this.data.tasks, index, localEntry);
            }

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, entry: targetEntry },
      });
    },

    async removeTask(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除任务：${this.data.tasks[index].key}？`
        );

        this.data.tasks.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async openEditWishActivityAchievementDialog(isCreated, entry, index) {
      let targetEntry = null;
      if (entry) {
        targetEntry = {
          type: entry.type,
          params: entry.params,
          rewards: entry.rewards,
        };
      }

      this.$dialogutil.open("EditWishActivityAchievementDialog", {
        closedCallback: async (entry) => {
          console.log("entry:", entry)

          if (entry != null) {
            let localEntry = {
              type: entry.type,
              params: entry.params,
              rewards: entry.rewards,
            };

            if (isCreated) {
              this.data.achievements.push(localEntry);
            } else {
              this.$set(this.data.achievements, index, localEntry);
            }

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, entry: targetEntry },
      });
    },

    async removeAchievement(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除成就：${this.data.achievements[index].type}？`
        );

        this.data.achievements.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async openEditActivityLeaderboardDialog(isCreated, entry, index) {
      let targetRankingEntry = null;
      if (entry) {
        targetRankingEntry = {
          rankRange: entry.range,
          reward: entry.rewards,
        };
      }

      let that = this;
      this.$dialogutil.open("EditActivityLeaderboardDialog", {
        closedCallback: async (rankingEntry) => {
          if (rankingEntry != null) {
            let localRankingEntry = {
              range: rankingEntry.rankRange,
              rewards: rankingEntry.reward,
            };

            if (isCreated) {
              that.data.leaderboard.rankingRanges.push(localRankingEntry);
            } else {
              this.$set(that.data.leaderboard.rankingRanges, index, localRankingEntry);
            }

            this.data.leaderboard.rankingRanges.sort((x, y) => {
              return x.range[0] - y.range[0];
            });

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, entry: targetRankingEntry },
      });
    },

    async removeLeaderboardRankingEntry(index) {
      try {
        let rankingEntry = this.data.leaderboard.rankingRanges[index];

        // 弹确认框
        await this.$confirm(
          `确认删除排名区间[${rankingEntry.range}]的排名奖励配置？`
        );
        this.data.leaderboard.rankingRanges.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        for (let index = 0; index < this.data.leaderboard.rankingRanges.length; index++) {
          if (index == 0) {
            continue;
          }
          let rankingEntry = this.data.leaderboard.rankingRanges[index];
          let preRankingEntry = this.data.leaderboard.rankingRanges[index - 1];
          if (rankingEntry.range[0] - preRankingEntry.range[1] != 1) {
            return { errMsg: "各个排名区之间必须前后衔接" };
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>